import { LegoElementInput } from './_Input/LegoElementInput';
import { LegoElementCheckbox } from './_Checkbox/LegoElementCheckbox';
import { LegoElementButton, LegoElementSubmitButtons } from './_Button/LegoElementButton';
import { LegoElementSelect } from './_Select/LegoElementSelect';
import { LegoElementTextarea } from './_Textarea/LegoElementTextarea';
import { LegoElementSwitch } from './_Switch/LegoElementSwitch';
import { LegoElementRichTextEditor } from './_RichTextEditor/LegoElementRichTextEditor';
import { LegoElementDatePicker } from './_DatePicker/LegoElementDatePicker';
import { LegoElementInputPassword } from './_InputPassword/LegoElementInputPassword';
import { LegoElementInputPhone } from './_InputPhone/LegoElementInputPhone';
import { LegoElementUploader } from './_Uploader/LegoElementTextarea';
import { LegoElementDialogHeader } from './_DialogHeader/LegoElementDialogHeader';

/** Стандартные элементы контроля для lego элементов */
export const LEGO_V2_ELEMENTS = {
  Input: LegoElementInput,
  InputPassword: LegoElementInputPassword,
  InputPhone: LegoElementInputPhone,
  Uploader: LegoElementUploader,
  Checkbox: LegoElementCheckbox,
  Button: LegoElementButton,
  SubmitButtons: LegoElementSubmitButtons,
  Select: LegoElementSelect,
  Textarea: LegoElementTextarea,
  Switch: LegoElementSwitch,
  RichTextEditor: LegoElementRichTextEditor,
  DatePicker: LegoElementDatePicker,
  DialogHeader: LegoElementDialogHeader,
} as const;
